import { NgModule } from '@angular/core'
import { ButtonIconDirective } from './button-icon.directive'

@NgModule({
    declarations: [ButtonIconDirective],
    exports: [ButtonIconDirective]
})
export class ButtonIconModule {}
